module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "half_1_2"
  }, [_c('div', {
    staticClass: "white-block wg_1"
  }, [_c('div', {
    staticClass: "patient-info-title wg_title"
  }, [(_vm.isCanWrite) ? _c('div', {
    staticClass: "sched_plus",
    on: {
      "click": function($event) {
        _vm.showForms('consultation')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Консультации")])]), _vm._v(" "), _c('div', {
    staticClass: "patient-form cont_wg"
  }, [_vm._l((_vm.consultations), function(item) {
    return _c('div', {
      staticClass: "patient-form-block pat_wg_box"
    }, [_c('div', {
      staticClass: "formButton list",
      on: {
        "click": function($event) {
          _vm.selectRecord(item)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.formName) + "\n\t\t\t\t")])])
  }), _vm._v(" "), (!_vm.consultations.length) ? _c('div', {
    staticClass: "no_records_wg"
  }, [_vm._v("\n\t\t\t\tЕще не было добавлено записей в эту категорию\n\t\t\t")]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99c3346a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Widgets/Consultation.vue
// module id = 639
// module chunks = 0